export const CONFIG = {
  MATERIALADDITION: {
    showBorders: true,
    rowAlternationEnabled: true,
    allowColumnReordering: true,
    allowColumnResizing: true,
    columnResizingMode: "widget",
    columnAutoWidth: true,
    columnChooser: {
      enabled: true,
      allowSearch: true,
      mode: "select",
    },
    headerFilter: {
      visible: true,
    },
    sorting: {
      mode: "multiple",
    },
    grouping: {
      contextMenuEnabled: true,
    },
    searchPanel: {
      visible: true,
    },
    filterRow: {
      visible: true,
      applyFilter: "auto",
    },
    // paging: {
    //   pageSize: 10,
    // },
    // pager: {
    //   showPageSizeSelector: true,
    //   allowedPageSizes: [5, 10, 20, 50],
    //   showInfo: true,
    // },
    export: {
      enabled: true,
      fileName: "Material Addition",
    },
    editing: {
      mode: "batch",
      allowUpdating: true,
      allowAdding: true,
      allowDeleting: true,
      useIcons: true,
    },

    onToolbarPreparing: function (e) {
      var dataGrid = e.component;
      var toolbarItems = e.toolbarOptions.items;
      // Adds a new item
      toolbarItems.unshift(
        {
          location: "after",
          template: "Manage Material",
        }
        // ,
        // {
        //   location: "after",
        //   widget: "dxButton",
        //   options: {
        //     icon: "refresh",
        //     hint: "Refresh",
        //     onClick: function () {
        //       dataGrid.refresh();
        //     },
        //   },
        // }
      );
    },
  },
};
